import script from "./AddNumberWhatsappDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNumberWhatsappDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddNumberWhatsappDialog.vue?vue&type=style&index=0&id=443488e2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-443488e2"]])

export default __exports__